import type { ReactNode } from "react";
import { Navigate } from "react-router";

import { useAuth } from "@/hooks/useAuth";
import { isCompanyEmployee } from "@/lib/companyRole";

/**
 * Route guard for the commercial pages (backend#1069): an employee of a
 * consultancy company sees no rates, terms or invoices, so a direct URL to
 * Financials redirects to the dashboard. Managers, one-person companies,
 * admins and users on an older backend (no `company_role`) pass through.
 */
export const CompanyManagerRoute = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  if (isCompanyEmployee(user)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};
